<div class="auth-modal">
  <form class="form" tuiForm>
    <label tuiLabel tuiAppearance="ai-label">
      <span class="ai-label">Код</span>
      <tui-textfield class="form__textfield">
        <input [formControl]="password" tuiAutoFocus tuiTextfield placeholder="Введите код" />
      </tui-textfield>

      @if (password.touched) {
        @if (password.hasError('required')) {
          <tui-error error="Код не может быть пустым"></tui-error>
        }
        @if (password.hasError('pattern')) {
          <tui-error error="Код может содержать только цифры"> </tui-error>
        }
        @if (password.hasError('invalidPassword')) {
          <tui-error [error]="password.getError('invalidPassword')"></tui-error>
        }
        @if (password.hasError('userPasswordExpired')) {
          <tui-notification size="m">
            Срок действия вашего кода истек.
            <button
              [disabled]="passwordModalStore.isLoading()"
              (click)="login()"
              tuiLink
              type="button"
            >
              Отправить код заново.
            </button></tui-notification
          >
        }
      }

      @if (passwordModalStore.isSentCodeNotificationShown()) {
        <tui-notification size="m">
          На ваш email был выслан код. Введите его в поле для ввода кода.
        </tui-notification>
      }
    </label>

    <footer>
      <button
        class="button"
        [loading]="passwordModalStore.isLoading()"
        [disabled]="!password.valid"
        (click)="loginWithPassword()"
        type="button"
        tuiButton
        appearance="ai-primary"
        size="m"
      >
        Авторизоваться
      </button>
    </footer>
  </form>
</div>
